import React from 'react';
import { connect } from 'react-redux';
import CyberComponent from 'containers/CyberComponent';
import { Col, Form, FormGroup, Button } from 'react-bootstrap';
import { Bubble, LoaderButton, ContinueLabel, Divider } from 'ctia-ui';
import FormElement from 'components/FormElement';
import { notifyMessages } from 'helpers/NotifyHelper';
import {
  pocFormValidate,
  makeEmailValidation,
  makePhoneValidation
} from 'helpers/ValidatorHelper';
import {
  handleInputChange,
  handleCheckboxGroupChange,
  createNewPoc,
  updateRequest,
  fetchPocs
} from 'actions/request';
import { submitWizardStep } from 'actions/wizard';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { showNotice } from 'actions/notifier';

class PocAdd extends CyberComponent {
  createPoc = callback => {
    const {
      user,
      request,
      createNewPoc,
      startPreloader,
      finishPreloader
    } = this.props;
    startPreloader();
    createNewPoc(request, user.requestOwnerCompanyId, callback).then(
      finishPreloader
    );
  };

  onSaveClick = () => {
    this.createPoc(this.updatePocCallback);
  };

  updatePocCallback = () => {
    const {
      request,
      updateRequest,
      finishPreloader,
      showNotice,
      fetchPocs,
      user
    } = this.props;

    const { id, pocId } = request;

    const rest = pocId ? { pocid: pocId } : {};

    updateRequest({ id, ...rest }).then(
      fetchPocs(user.requestOwnerCompanyId).then(() => {
        finishPreloader();
        showNotice(notifyMessages.requestUpdatedSuccessfully);
      })
    );
  };

  onContinueClick = () => {
    this.createPoc(this.onSubmitWizard);
  };

  onSubmitWizard = () => {
    this.props.submitWizardStep(this.props.wizard);
    this.props.finishPreloader();
  };

  render() {
    const { show, request, handleInputChange, isNew, user } = this.props;

    if (!show) return null;

    const emailValidation = makeEmailValidation(request);
    const phoneValidation = makePhoneValidation(request);
    const isEditable = user.canEditRequest;

    return (
      <div>
        <Bubble show={isEditable}>
          Please enter the <strong>Point of Contact (POC)</strong> for this
          request
          {request.pocs.length > 0 && (
            <span>
              or{' '}
              <Button
                bsSize="small"
                bsStyle="primary"
                onClick={() => this.props.toggleSelector(true)}
              >
                Select from POC list
              </Button>
            </span>
          )}
        </Bubble>
        <Bubble show={!isEditable}>
          Please enter the <strong>Point of Contact (POC)</strong> for this
          request
        </Bubble>
        <Form horizontal>
          <FormElement
            type="text"
            id="pocFirstName"
            label="First Name"
            value={request.pocFirstName}
            onChange={handleInputChange}
            placeholder="First name for POC"
            editable={isEditable}
            maxLength={50}
          />
          <FormElement
            type="text"
            id="pocLastName"
            label="Last Name"
            value={request.pocLastName}
            onChange={handleInputChange}
            placeholder="Last Name for POC"
            editable={isEditable}
            maxLength={50}
          />
          <FormElement
            type="text"
            id="pocEmail"
            label="POC Email"
            value={request.pocEmail}
            onChange={handleInputChange}
            placeholder="Please enter a valid company email address"
            validationState={emailValidation.state}
            validationMessage={emailValidation.message}
            editable={isEditable}
            maxLength={50}
          />
          <FormElement
            type="text"
            id="pocPhone"
            label="POC Phone"
            value={request.pocPhone}
            onChange={handleInputChange}
            placeholder="Please enter a contact phone number"
            validationState={phoneValidation.state}
            validationMessage={phoneValidation.message}
            editable={isEditable}
            maxLength={18}
          />
          <Divider />
          <FormGroup>
            <Col sm={3} />
            <Col sm={4}>
              <LoaderButton
                bsStyle="default"
                text="Save changes"
                disabled={!pocFormValidate(request)}
                isLoading={request.isLoading}
                onClick={this.onSaveClick}
                show={isEditable && request.id > 0}
              />
            </Col>
            <Col sm={5} className="text-right">
              <LoaderButton
                bsStyle="info"
                text={<ContinueLabel />}
                disabled={!pocFormValidate(request)}
                isLoading={request.isLoading}
                onClick={this.onContinueClick}
                show={isNew}
              />
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

function mapStateToProps({ request, wizard, user }) {
  return { request, wizard, user };
}

export default connect(
  mapStateToProps,
  {
    handleInputChange,
    handleCheckboxGroupChange,
    submitWizardStep,
    startPreloader,
    finishPreloader,
    createNewPoc,
    updateRequest,
    showNotice,
    fetchPocs
  }
)(PocAdd);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/PocAdd.js